import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { createAdminCompetitionEvent, fetchAdminCompetitionEvent, updateAdminCompetitionEvent } from '../../api/admin/api';
import Button from '../../components/Button'
import Header from '../../components/Header'
import Stack from '../../components/Stack'
import CheckBox from '../../components/Checkbox'
import FlashMessage from '../../components/FlashMessage'

export default function CreateCompetitionEventForm() {
  const { id, event_id, editing } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState('')
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [registrationStartDate, setRegistrationStartDate] = useState('');
  const [registrationEndDate, setRegistrationEndDate] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [flashMessage, setFlashMessage] = useState('');
  const [type, setType] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      competition_id: id,
      start_date: startDate,
      end_date: endDate,
      is_active: isActive,
      id: event_id,
      name: name,
      registration_starts_at: registrationStartDate,
      registration_ends_at: registrationEndDate,
    };

    let res;
    try {
      if(editing === 'true') {
        res = await updateAdminCompetitionEvent(payload);
      } else {
        res = await createAdminCompetitionEvent(payload);
      }

      if (res.status === 201 || res.ok) {
        setType('success');
        setFlashMessage('Event Saved Successfully')
        navigate(`/admin/competitions/${id}`);
      } else {
        setType('error');
        setFlashMessage('Error saving the event.')
      }
    } catch (error) {
      setType('error');
      setFlashMessage('Error saving the event.')
    }
  };

  useEffect(() => {
    if(editing === 'true') {
      fetchAdminCompetitionEvent(event_id)
        .then(res => {
          const { start_date, end_date, is_active, name, registration_starts_at, registration_ends_at } = res

          setStartDate(start_date)
          setEndDate(end_date)
          setIsActive(is_active)
          setName(name)
          setRegistrationStartDate(registration_starts_at)
          setRegistrationEndDate(registration_ends_at)
        })
        .catch(err => {
          setFlashMessage(`Failed to get Comp Event: ${err}`)
          setType('error')
        })
    }
  }, [])


  return (
    <div className='w-11/12 sm:w-6/12 rounded-md shadow-md p-6 flex flex-col justify-start align-evenly gap-4 bg-white'>
      <FlashMessage
        message={flashMessage}
        type={type}
        onClose={() => {
          setFlashMessage('')
          setType('')
        }}
      />
      <Stack width="full" justify='start' align='start' className='gap-2'>
        <Header size="xl">{editing === 'true' ? 'Edit' : 'Create New' } Event</Header>
        <p className='text-xs'>Set time frame for the event.</p>
      </Stack>

      <form className="space-y-4 w-full" onSubmit={handleSubmit}>
        <div className='w-full'>
          <label className="block text-xs font-medium text-gray-700">Name</label>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            required
            className="mt-1 w-full border border-gray-300 rounded-md p-2"
          />
        </div>

        <div className='w-full'>
          <label className="block text-xs font-medium text-gray-700">Registration Start Date</label>
          <input
            type="date"
            value={registrationStartDate}
            onChange={e => setRegistrationStartDate(e.target.value)}
            required
            className="mt-1 w-full border border-gray-300 rounded-md p-2"
          />
        </div>

        <div className='w-full'>
          <label className="block text-xs font-medium text-gray-700">Registration End Date</label>
          <input
            type="date"
            value={registrationEndDate}
            onChange={e => setRegistrationEndDate(e.target.value)}
            className="mt-1 w-full border border-gray-300 rounded-md p-2"
          />
        </div>

        <div className='w-full'>
          <label className="block text-xs font-medium text-gray-700">Start Date</label>
          <input
            type="date"
            value={startDate}
            onChange={e => setStartDate(e.target.value)}
            required
            className="mt-1 w-full border border-gray-300 rounded-md p-2"
          />
        </div>

        <div className='w-full'>
          <label className="block text-xs font-medium text-gray-700">End Date</label>
          <input
            type="date"
            value={endDate}
            onChange={e => setEndDate(e.target.value)}
            className="mt-1 w-full border border-gray-300 rounded-md p-2"
          />
        </div>

        <div className="flex items-center">
          <CheckBox value={isActive} label={'Active'} handleClick={setIsActive} className="text-sm"/>
        </div>

        <Stack className="w-full gap-2" direction='row' justify='evenly'>
          <Button
            type="button"
            className="px-2 w-1/2 bg-trans-custom text-sm border border-black"
            onClickMethod={() => navigate(`/competitions/${id}`)}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            className="px-2 w-1/2 text-sm"
          >
            Submit
          </Button>
        </Stack>
      </form>
    </div>
  );
}
